import { getElectronicPaymentMethods } from '../../services/paymentMethodService';
import { parseCashRegisterAmountInput } from '../../utils/posCurrencyUtils';

export const CASH_PROVIDER_ID = 'cash';

/** Liste des lignes saisie : espèces + chaque fournisseur électronique. */
export function getCashRegisterProviderRows() {
  return [
    { id: CASH_PROVIDER_ID, category: 'cash' },
    ...getElectronicPaymentMethods().map((m) => ({ id: m.id, category: 'electronic' }))
  ];
}

export function buildEmptyProviderInputs() {
  const inputs = {};
  getCashRegisterProviderRows().forEach((row) => {
    inputs[row.id] = '';
  });
  return inputs;
}

/** Champ vide → 0 (MRO). */
export function parseProviderInputs(providerInputs, currencyType = 'MRO') {
  const amountsByProvider = {};
  let cashAmount = 0;
  let electronicAmount = 0;

  getCashRegisterProviderRows().forEach((row) => {
    const raw = providerInputs?.[row.id];
    const mro = parseCashRegisterAmountInput(raw ?? '', currencyType);
    amountsByProvider[row.id] = mro;
    if (row.id === CASH_PROVIDER_ID) {
      cashAmount = mro;
    } else {
      electronicAmount += mro;
    }
  });

  return {
    cashAmount,
    electronicAmount,
    totalAmount: cashAmount + electronicAmount,
    amountsByProvider
  };
}
